import { Controller } from "@hotwired/stimulus"

// Lê os flash messages renderizados pelo `_flash.html.erb` e dispara um
// CustomEvent("toast") para o toast_controller exibir. Roda em DOMContentLoaded
// e em cada turbo:load (compatível com Turbo navigation cache).
export default class extends Controller {
  static targets = ["payload"]

  connect() {
    // Próximo tick: garante que o toast_container já está montado.
    requestAnimationFrame(() => {
      this.payloadTargets.forEach((el) => {
        document.dispatchEvent(new CustomEvent("toast", {
          detail: {
            message: el.dataset.message,
            variant: el.dataset.variant
          }
        }))
      })
      this.element.remove()
    })
  }
}
